import { ReactSVG } from 'react-svg';
import { hideDecorativeSvg } from '@/lib/a11y';
import s from './Button.module.css';
import { ButtonProps } from '@/types/model';

const Button = ({
  label,
  onClick,
  svg = '/icons/boton.svg',
  type = 'button',
  disabled = false
}: ButtonProps) => {
  return (
    <button onClick={onClick} className={s.button} type={type} disabled={disabled}>
      <div className={s.button__svg}>
        <ReactSVG src={svg} className={s.svg} beforeInjection={hideDecorativeSvg} />
      </div>
      <p className={s.button__text}>{label}</p>
    </button>
  );
};

export default Button;
